import { http, HttpResponse } from 'msw'

export const mockCreateCustomerCustomField = http.post(
  '/my-business/api/agency/v1/customers/:customerId/custom-field',
  () => {
    return HttpResponse.json(
      { timestamp: new Date().toISOString() },
      { status: 201 },
    )
  },
)
